import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {isSmallScreen} from "../../../../UtilsLib";
import {merchantStyleRule} from "../../../Security";
import {iFrameState} from "../../../../services/IFrameState";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {DiscountCodeInput} from "./components/DiscountCodeInput";
import {SOUTHERN_THING_ALIAS} from "../../../../../blink-sdk/Constants";
import {CheckboxInput} from "../../../../../stem-core/src/ui/input/checkbox/CheckboxInput.jsx";
import {Messages} from "../../../../Messages";
import {SubscriptionFlowType} from "../../../flows/steps/SubscriptionPlanFlowStep.js";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {PanelText} from "../../../panel-elements/PanelText.jsx";
import {Flow} from "../../../flows/Flow.js";
import {PanelImage} from "../../../panel-elements/PanelImage.jsx";
import {SubscriptionCardsList} from "./components/SubscriptionCardsList.jsx";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw.js";

class SubscriptionPlanPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    content = {
        width: null,
        textAlign: "center",
    }

    @styleRule
    discountCodeInput = {
        marginBottom: 24,
    };

    @styleRule
    shareNameCheckbox = {
        fontSize: () => this.themeProps.FONT_SIZE_LARGE + " !important",
        fontWeight: this.themeProps.FONT_WEIGHT_LIGHT,
        margin: "0 auto 12px",
        maxWidth: 524,
        display: "flex",
    };

    messageObject = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
        textAlign: "center",
        marginBottom: () => (isSmallScreen() ? 18 : 24),
        width: "100%",
        ":last-child": {
            marginBottom: 0,
        },
    };

    @styleRule
    message = {
        ...this.messageObject,
        fontSize: this.themeProps.FONT_SIZE_LARGE,
    };

    @merchantStyleRule
    panelTextStyle = {
        ...iFrameState.textStyle,
    };

    @merchantStyleRule
    panelFooterSeparatorStyle = {
        marginLeft: "auto",
        marginRight: "auto",
        ...iFrameState.footerSeparatorStyle,
    };

    @merchantStyleRule
    panelFooterTextStyle = {
        marginLeft: "auto",
        marginRight: "auto",
        ...iFrameState.footerTextStyle,
    };

    @styleRule
    subscriptionText = {
        margin: "0px auto",
        maxWidth: 700, // TODO @panelapp This shouldn't be hardcoded
        display: "flex",
        flexDirection: isSmallScreen() ? "column" : "row",
        justifyContent: "center",
        alignItems: "flex-start"
    }

    @styleRule
    subscribeImageLogo = {
        width: 150,
        marginTop: 0
    }
}

@autoredraw(iFrameState)
@registerStyle(SubscriptionPlanPanelStyle)
export class SubscriptionPlanPanel extends BasePanelPage {
    renderSubscriptionText() {
        const {styleSheet} = this;
        const panelText = iFrameState.iframeParams.text; // TODO @cleanup shit is also here
        const {subscribeImageLogo} = iFrameState.iframeParams;
        const currentSubscription = iFrameUserDataService.getActiveSubscription();
        const {subscriptionFlowType} = Flow.subscriptionPlan;

        if (subscriptionFlowType === SubscriptionFlowType.EDIT_SUBSCRIPTION) {
            return <div className={styleSheet.message + styleSheet.panelTextStyle}>
                {Messages.currentSubscriptionPlan(currentSubscription.coverage.name, currentSubscription.billingPlan.getCycleDuration(true))}
            </div>
        }

        return <div className={styleSheet.subscriptionText}>
            {subscribeImageLogo && <PanelImage src={subscribeImageLogo} className={styleSheet.subscribeImageLogo}/>}
            {panelText && <PanelText className={styleSheet.panelTextStyle}>{panelText}</PanelText>}
        </div>;
    }

    render() {
        const {styleSheet} = this;
        const merchant = iFrameMerchantService.getMerchant();
        const {footerText, hideDiscountCodeInput} = iFrameState.iframeParams;

        return [
            this.renderSubscriptionText(),
            <SubscriptionCardsList style={{marginBottom: 24}}/>,

            !hideDiscountCodeInput && merchant.hasSubscriptionDiscountCodeEnabled() && <DiscountCodeInput
                className={styleSheet.discountCodeInput}
                initialValue={Flow.subscriptionPlan.discountCode || ""}
                discountApplied={this.isDiscountApplied()}
                onCodeInput={code => this.checkDiscountCode(code)}
            />,

            iFrameMerchantService.isMerchant(SOUTHERN_THING_ALIAS) && Flow.subscriptionPlan.subscriptionFlowType === SubscriptionFlowType.SUBSCRIBE &&
            <CheckboxInput
                ref="shareNameCheckbox"
                testId={"shareNameCheckbox"}
                className={styleSheet.shareNameCheckbox}
                initialValue={Flow.subscriptionPlan.shareName}
                onChange={enabled => this.handleShareNameCheckboxToggle(enabled)}
                label={Messages.subscribeShareUserName(merchant.getName())}
            />,

            <div className={styleSheet.panelFooterSeparatorStyle}/>,

            footerText && <PanelText className={styleSheet.panelFooterTextStyle}>{footerText}</PanelText>,

            Flow.subscriptionPlan.renderBackButton(),
        ]
    }

    isDiscountApplied() {
        return !!Flow.subscriptionPlan.discountCode;
    }

    async checkDiscountCode(discountCode) {
        Flow.subscriptionPlan.update({discountCode});
        await Flow.subscriptionPlan.fetchPrices(Flow.address.selectedValue);
    }

    handleShareNameCheckboxToggle(enabled) {
        Flow.subscriptionPlan.update({shareName: enabled});
        this.redraw();
    }

    async onMount() {
        super.onMount();

        this.attachListener(Flow.subscriptionPlan, () => this.redraw());
    }
}
